import React from "react";
import Styles from "./CardItem.module.scss";
import {ICardItem} from "./types";
import cardIcon from "@assets/icons/card.svg";
import trashIcon from "@assets/icons/closeIconRed.svg";
import {useAppDispatch} from "@redux/store";
import {setCardid} from "@redux/profile/cards/slice";
import {useSelector} from "react-redux";
import {getCardSelector} from "@redux/profile/cards/selectors";
import {fetchDelCards, fetchGetCards} from "@redux/profile/cards/asyncActions";
import {ModalTexts} from "@resources/locale";
import {Button, Modal} from "@/components";

export const CardItem: React.FC<ICardItem> = (props) => {
	const {onPage = "profile", selectFunc} = props;

	const [isOpenModal, setIsOpenModal] = React.useState<boolean>(false);
	const dispatch = useAppDispatch();
	const {cardId} = useSelector(getCardSelector);

	const handleCloseModalNoConfirm = () => {
		setIsOpenModal(false);
	};

	const handleCloseModalConfirm = async () => {
		await dispatch(fetchDelCards(cardId));
		setIsOpenModal(false);
		await dispatch(fetchGetCards());
	};

	function handleRemove(id: number) {
		setIsOpenModal(true);
		dispatch(setCardid(id));
	}

	const handleSelectCard = () => {
		if (onPage === "payment" && selectFunc) {
			selectFunc(props.data.id);
		}
	};

	return (
		<div className={Styles.item} data-type={props.dataType} onClick={handleSelectCard}>
			<span className={Styles.cardNumber}>
				<img src={cardIcon}/>
				<span>{props.data.title}</span>
			</span>
			<div
				onClick={() => handleRemove(props.data.id)}
				className={`${Styles.item_trash}`}
			>
				<img src={trashIcon}/>
			</div>
			{isOpenModal ? (
				<Modal
					title={ModalTexts.addCard.confirmation.TITLE}
					subTitle={ModalTexts.addCard.confirmation.SUB_TITLE}
					isOpen={isOpenModal}
					setIsOpen={setIsOpenModal}
					closeFunc={handleCloseModalNoConfirm}
					mobileContentSize="fixed"
				>
					<div className={Styles.buttons}>
						<Button onClickFunc={handleCloseModalNoConfirm}>
							Нет
						</Button>
						<Button newStyles={Styles.button} onClickFunc={handleCloseModalConfirm}>
							Да
						</Button>
					</div>
				</Modal>
			) : null}
		</div>
	);
};
